import React from 'react';
import ReactMarkdown from 'react-markdown';
import Countdown from 'react-countdown';
import { connect } from 'unistore/react';

import SmallPulse from '@components/Loader/smallPulse';
import CExpandCollapse from '@components/ExpandCollapse';
import { Button } from '@components';
import IfElse from '@components/IfElse';

import { getPairDetails } from '@utils/params';
import { Harpic } from '@utils/customLib';

const ContestTimer = ({ completed, days, hours, minutes, seconds }) => {
	if (!completed) {
		return (
			<>
				{hours || days ? `${hours}h: ` : null}
				{minutes}m : {seconds}s
			</>
		);
	}
	return null;
};

class BbTcContest extends React.PureComponent {
	callForceUpdate = () => {
		this.forceUpdate();
	};

	render() {
		const {
			startTime,
			endTime,
			countDownTimer,
			title,
			text,
			coin: contestCoin,
			leaderboard,
			link,
			currentCoin,
			currentMarket,
			tradeCoins,
		} = this.props;

		if (tradeCoins.indexOf(contestCoin.toLowerCase()) > -1) {
			const {
				coin,
				basePair: { market_id },
			} = getPairDetails(contestCoin);
			const currentTime = Date.now() / 1000;

			if (coin === currentCoin && currentMarket === market_id) {
				if (
					currentTime > startTime - 43200 &&
					endTime + 3600 > currentTime
				) {
					return (
						<CExpandCollapse
							heading={
								<div className="flex items-start">
									<SmallPulse
										className="bb__pulse-svg inline-block align-middle mr-2 text-pastelRed mt-2"
										style={{
											height: '6px',
											width: '6px',
										}}
									/>{' '}
									<ReactMarkdown
										components={{
											p: ({ children, ...props }) => (
												<span
													className="text-primary"
													{...props}
												>
													{children}{' '}
													<IfElse
														condition={
															currentTime <
															startTime
														}
														then={
															countDownTimer ===
																1 && (
																<span className="font-normal">
																	Starts in:{' '}
																	<Countdown
																		date={
																			new Date(
																				startTime *
																					1000
																			)
																		}
																		key={
																			startTime
																		}
																		renderer={
																			ContestTimer
																		}
																		onComplete={
																			this
																				.callForceUpdate
																		}
																	/>
																</span>
															)
														}
														else={
															<IfElse
																condition={
																	endTime <
																	currentTime
																}
																then={
																	<span className="font-normal">
																		Already
																		Ended!
																	</span>
																}
																else={
																	countDownTimer ===
																		1 && (
																		<span className="font-normal">
																			Ends
																			in:{' '}
																			<Countdown
																				date={
																					new Date(
																						endTime *
																							1000
																					)
																				}
																				key={
																					endTime
																				}
																				renderer={
																					ContestTimer
																				}
																				onComplete={
																					this
																						.callForceUpdate
																				}
																			/>
																		</span>
																	)
																}
															/>
														}
													/>
												</span>
											),
										}}
									>
										{title}
									</ReactMarkdown>
								</div>
							}
							className="pl-12 my-4"
						>
							<ReactMarkdown
								components={{
									p: props => (
										<div className="mb-4 mt-2" {...props} />
									),
								}}
							>
								{text}
							</ReactMarkdown>
							{leaderboard !== 0 && (
								<Button
									size="tiny"
									variant="outline"
									href="/leaderboard"
									target="_blank"
									rel="noopener noreferrer"
									className="mr-4"
								>
									View Leaderboard
								</Button>
							)}
							{link && link.web && (
								<Button
									size="tiny"
									href={link.web}
									target="_blank"
									rel="noopener noreferrer nofollow"
								>
									{Harpic(link.text)}
								</Button>
							)}
						</CExpandCollapse>
					);
				}
			}
		}
		return null;
	}
}

export default connect('tradeCoins')(BbTcContest);
